import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';

export const WaveLeft = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2218"
    height="819"
    viewBox="0 0 2218 819.114"
    className={className}
    {...props}>
    <path
      d="M2218,819H0V11s91.93-49.07,200,59c82.87,82.87,135.75,200.97,330,125,284.31-111.2,252.82,256.55,527,151,226-87,194.64,269.68,461,174,286-102.73,182.53,240.74,442,146C2218.18,571.715,2218,819,2218,819Z"
      transform="translate(0 0.119)"
      fill="#fff"
      className="l-homepage-hero-lab__wave-left-path"
    />
  </svg>
);

WaveLeft.propTypes = {
  className: PropTypes.string,
};

WaveLeft.defaultProps = {
  className: '',
};
